import React from 'react';
import { BORDER_LIGHT, BG_CARD, TEXT_DARK, TEXT_MUTED } from './designTokens';

interface ZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetFit: () => void;
  currentScale: number;
}

const buttonStyle: React.CSSProperties = {
  width: '32px',
  height: '32px',
  border: `1px solid ${BORDER_LIGHT}`,
  borderRadius: '4px',
  backgroundColor: BG_CARD,
  color: TEXT_DARK,
  fontSize: '1rem',
  fontWeight: 600,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'opacity 0.15s',
};

const disabledStyle: React.CSSProperties = {
  ...buttonStyle,
  opacity: 0.4,
  cursor: 'not-allowed',
};

export function ZoomControls({ onZoomIn, onZoomOut, onResetFit, currentScale }: ZoomControlsProps) {
  const atMax = currentScale >= 2.0;
  const atMin = currentScale <= 0.5;
  const zoomPercent = Math.round(currentScale * 100);

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '12px',
        right: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: 'center',
        zIndex: 10,
      }}
    >
      <button
        style={atMax ? disabledStyle : buttonStyle}
        onClick={onZoomIn}
        disabled={atMax}
        aria-label="Zoom in"
        title="Zoom in"
      >
        +
      </button>
      <button
        style={atMin ? disabledStyle : buttonStyle}
        onClick={onZoomOut}
        disabled={atMin}
        aria-label="Zoom out"
        title="Zoom out"
      >
        −
      </button>
      <button
        style={buttonStyle}
        onClick={onResetFit}
        aria-label="Reset zoom to fit"
        title="Reset to fit"
      >
        ⊡
      </button>
      <span style={{ fontSize: '0.65rem', color: TEXT_MUTED, marginTop: '2px' }}>
        {zoomPercent}%
      </span>
    </div>
  );
}
